// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"e5732a1b","787":"e0179f71","802":"8a7ae5b5"}[chunkId] + ".chunk.js";
};